import { combineReducers } from 'redux';

import auth from 'modules/auth';
import Survey from 'modules/survey';

export default combineReducers({
  auth,
  survey: Survey.reducer,
});
